import InView from 'inview';
import { slideToggle } from '../global/helpers';

const initPageNav = () => {
	const pageNav = document.querySelectorAll('.em-page-navigation');

	pageNav.forEach((nav) => {
		const navContainer = nav.querySelector('.em-page-navigation__nav');
		const label = nav.querySelector('.em-page-navigation__mobile-label');
		const navLinks = nav.querySelectorAll('a');

		label.addEventListener('click', () => {
			label.classList.toggle('active');
			slideToggle(navContainer);
		});

		navContainer.addEventListener('click', () => {
			const mql = window.matchMedia('(max-width: 1141px)');
			if (mql.matches) {
				label.classList.toggle('active');
				slideToggle(navContainer);
			}
		});

		navLinks.forEach((link) => {
			InView(document.querySelector(link.hash), (isInView, data) => {
				if (isInView && data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
					navLinks.forEach((link) => {
						link.classList.remove('active');
					});
					link.classList.add('active');
				}
			});
		});
	});
};

initPageNav();
